import ArrowLeft from "@/assets/ArrowLeft.svg";
import { Description, Image, Title } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import CTA from "@/ui/CTA";

export const Banner = ({ className, title, image, description, button, showBack, backButtonLabel, backButtonHref }) => {
  return (
    <div className={clsx(className, classes.header, { "has-img": image })}>
      <img className={classes.header__img} src={image?.url} resize={false} alt="Header image" />
      <div className={clsx(classes.header__body, "py-3 p-md-5")}>
        <Container>
          {showBack && (
            <Row>
              <Col xs={12} md={8}>
                <a className={clsx(classes.back, "mb-3")} href={backButtonHref}>
                  <ArrowLeft />
                  {backButtonLabel}
                </a>
                <Title className="mb-0" title={title} tag="h1" />
              </Col>
            </Row>
          )}
          {!showBack && (
            <Row>
              <Col xs={12} md={8}>
                <Title className="mb-0" title={title} tag="h1" />
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={12} md={4}>
              <Description className="mt-4" description={description} />
              {button
                ? button.map((btn, k) => (
                    <CTA key={k} label={btn.label} href={btn.href} className={clsx("mt-4")} variant={btn.variant} />
                  ))
                : null}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Banner;
